import { useState } from 'react';
import { useTeamOverview } from '../../hooks/use-team-overview';
import { PullToRefresh } from '../../components/PullToRefresh';
import PromoterCard from '../../components/supervisor/PromoterCard';
import { Search, Users } from 'lucide-react';

export default function TeamList() {
  const { data, isLoading, refetch } = useTeamOverview();
  const [search, setSearch] = useState('');

  if (isLoading || !data) {
    return (
      <div className="min-h-screen bg-gray-50 p-4 space-y-3">
        <div className="h-10 bg-gray-200 rounded-lg animate-pulse" />
        {[1, 2, 3, 4].map(i => <div key={i} className="h-24 bg-gray-200 rounded-xl animate-pulse" />)}
      </div>
    );
  }

  const filtered = data.promoters.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <PullToRefresh onRefresh={() => refetch().then(() => {})}>
      <div className="min-h-screen bg-gray-50 pb-20">
        <div className="bg-white px-4 pt-safe pb-3 border-b border-gray-100">
          <h1 className="text-lg font-semibold text-gray-900 mb-3">Equipe</h1>
          <div className="relative">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar promotor..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="w-full pl-9 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
            />
          </div>
        </div>

        <div className="p-4 space-y-2">
          <p className="text-xs text-gray-400 mb-1">
            {search ? `${filtered.length} de ${data.promoters.length}` : `${data.promoters.length} promotores`}
          </p>
          {filtered.length === 0 ? (
            <div className="bg-white rounded-xl border border-gray-100 p-8 text-center">
              <Users size={32} className="mx-auto text-gray-300 mb-2" />
              <p className="text-sm text-gray-500">{search ? 'Nenhum resultado' : 'Nenhum promotor'}</p>
            </div>
          ) : (
            filtered.map(p => <PromoterCard key={p.promoter_id} promoter={p} />)
          )}
        </div>
      </div>
    </PullToRefresh>
  );
}
